import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getCartList } from '../features/cartSlice'
import { GoInfo } from "react-icons/go";
import CartBox from '../components/CartBox';
import Thanks from '../components/Thanks';
import api from '../controller/api';

export default function Cart() {
    const cartList = useSelector(getCartList)
    const [alertCheck, setAlertCheck] = useState(false)

    return (
        <div className='page-details'>
            <h2>Your cart</h2>
            <span className='highlight-1'><GoInfo size="20" /> Home service Free for all orders over Rs. 999!</span>
            {cartList.length > 0 ? <CartBox setAlertCheck={setAlertCheck} /> : <div className='empty-box'>
                {alertCheck && <Thanks />}
                <p>Cart is Empty</p>
                <Link to="/" className='btn-credential'>Continue Shopping</Link>
            </div>}
        </div>
    )
}
